import DropdownQuantities from "components/Product/DropdownQuantities"
import React from "react"
import PropTypes from "prop-types"
import { Icon, Input, Popup, Button, Form, Dropdown } from "semantic-ui-react"
import shop from "shop/shop"
import "style/ProductQuantityGroup.scss"

const CartActions = ( { cart, product } ) => {
  return (
    <Form.Input>
      <Button
        onClick={() => {
          cart.remove( product )
        }}
        className="btn-square"
        type="default"><i className="icon-cancel"/></Button>
    </Form.Input>
  )
}

CartActions.propTypes = {
  cart   : PropTypes.object,
  product: PropTypes.object,
}

const ListActions = ( { list, product } ) => {
  return (
    <Form.Input>
      <Button
        onClick={() => {
          list.remove( product )
        }}
        className="btn-square"
        type="default"><i className="icon-cancel"/></Button>
      <Button
        onClick={() => {
          list.toCart( product )
        }}
        className="btn-square"
        type="primary"><i className="icon-cart-plus"/></Button>
    </Form.Input>
  )
}

const noop = () => {
}

ListActions.propTypes = {
  list   : PropTypes.object,
  product: PropTypes.object,
}

const ProductQuantityGroup = React.forwardRef( ( { onKeyEnter, showMaxVE, product, className, cart, list, index, large, onChange, onAdd, onError = noop, showVE = true }, ref ) => {

    const selectedValue = `${product.unit_multi}::${product.unit_id}`
    const veOptions = product.quantities.map( ( qty ) => {
      return {
        label: `${qty.multi} ${translate( "Stück" )}`,
        value: `${qty.multi}::${qty.map_desc_id}`,
        key  : `${qty.multi}::${qty.map_desc_id}`
      }
    } )

    const showVEWarning = shop.config.checkout.limitToStock && (product.count >= Math.floor( product.stock / product.unit_multi ))
    return (
      <div className={`ProductQuantityGroup ${className}`}>
        {showVEWarning &&
        <Popup
          content="Keine weiteren Artikel auf Lager"
          trigger={<div className="pb2"><Button fluid size="tiny" icon="warning" color="yellow" title="Keine weiteren Artikel auf Lager"/></div>}
        />}
        <div className="flex justify-center items-center ">
          <div className="flex justify-center items-center  pr2">
            <Button
              attached={"left"}
              icon="minus"
              onClick={() => {
                product.warning = false
                let count = Math.max( 0, product.count - 1 )
                let ok = product.validateCount( count )
                if ( !ok ) {
                  product.warning = translate( "Maximale Abnahmemenge erreicht" )
                  onChange( { product } )
                  return false
                }

                product.count = count
                if ( shop.config.checkout.limitToStock ) product.count = getProductCount( product )
                onChange( { product } )
              }}/>
            <Input
              className={"tc pa1 CountInput"}
              ref={ref}
              tabIndex={index}
              onKeyPress={e => {
                if ( e.key === "Enter" ) {
                  onKeyEnter && onKeyEnter()
                }
              }}
              onChange={( e ) => {
                product.warning = false
                let count = Number( e.target.value )
                let ok = product.validateCount( count )
                if ( !ok ) {
                  product.warning = translate( "Maximale Abnahmemenge erreicht" )
                  onError( { error: product.warning } )
                  onChange( { product } )
                  return
                }
                if ( isNaN( count ) ) return
                product.count = Math.max( 0, count )
                if ( shop.config.checkout.limitToStock ) product.count = getProductCount( product )
                onChange( { product } )
              }}
              pattern="[0-9]*"
              inputMode="numeric"
              value={product.count}
              placeholder="0"/>
            <Button
              icon={"plus"}
              attached={"right"}
              onClick={() => {
                product.warning = false
                let count = Math.max( 0, product.count + 1 )
                let ok = product.validateCount( count )
                if ( !ok ) {
                  product.warning = translate( "Maximale Abnahmemenge erreicht" )
                  onChange( { product } )
                  return false
                }
                product.count = count

                if ( shop.config.checkout.limitToStock ) product.count = getProductCount( product )
                onChange( { product } )
              }}/>
          </div>

          {/* VE SELECTOR */}
          {(showVE) && <Form.Input className="mr1">
            <DropdownQuantities
              product={product}
              onChange={() => {
                if ( shop.config.checkout.limitToStock ) product.count = getProductCount( product )
                onChange( { product } )
              }}/>
            {/*<Dropdown*/}
            {/*  selection*/}
            {/*  className="qty-select" style={{ marginBottom: 0, minWidth: "95px" }} options={veOptions}*/}
            {/*  value={selectedValue} onChange={( event ) => {*/}
            {/*  const { value } = event.target*/}
            {/*  console.log( "SELEC", value )*/}
            {/*  const qty = value.split( "::" ) // Sad face.*/}
            {/*  product.unit_multi = Number( qty[ 0 ] )*/}
            {/*  product.unit_id = qty[ 1 ]*/}
            {/*  if ( shop.config.checkout.limitToStock ) product.count = getProductCount( product )*/}
            {/*  onChange( { product } )*/}
            {/*}}/>*/}
          </Form.Input>}

        </div>


        {!large && list ? <ListActions list={list} product={product}/> : null}
        {!large && cart ? <CartActions cart={cart} product={product}/> : null}
        {large && onAdd ? <Button type="primary" onClick={() => {
          if ( product.count === 0 ) product.count = 1
          if ( shop.config.checkout.limitToStock ) product.count = getProductCount( product )
          onAdd( { product } )
        }}><Icon name="cart"/> {translate( "cart.cart" )}</Button> : null}

      </div>
    )
  }
)

const getProductCount = ( product ) => {
  return Math.max( 0, Math.min( product.count, Math.floor( product.stock / product.unit_multi ) ) )
}

// props.cart and props.list are marked optional since we need either one or the other.
ProductQuantityGroup.propTypes = {
  product : PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onAdd   : PropTypes.func,
  cart    : PropTypes.object,
  list    : PropTypes.object,
  index   : PropTypes.number
}

export default ProductQuantityGroup



// WEBPACK FOOTER //
// ./src/components/Product/ProductQuantityGroup.js